import * as S from './styles'

import { useModal } from '@/contexts/ModalContext'

import { modalTypes } from '@/constants/modalTypes'

import AlertStyleModal, { AlertStyleModalConfig } from './Layouts/Alert'
import EditAvatarModal from './Templates/EditAvatar'
import EditLanguageModal from './Templates/EditLanguage'
import EditPasswordModal from './Templates/EditPassword'
import EditPersonalDataModal from './Templates/EditPersonalData'
import EditGuardianDataModal from './Templates/EditGuardianData'
import ViewerHelpModal from './Templates/ViewerHelp'
import BannerVideoModal from './Templates/BannerVideo'
import RenameCollectionModal, {
  RenameCollectionModalConfig
} from './Templates/RenameCollection'
import DeleteCollectionModal, {
  DeleteCollectionModalConfig
} from './Templates/DeleteCollection'
import MoveCollectionModal, {
  MoveCollectionModalConfig
} from './Templates/MoveCollection'
import MoveCollectionDropModal, {
  MoveCollectionDropModalConfig
} from './Templates/MoveCollectionDrop'
import CreateFolderCollectionModal, {
  CreateFolderCollectionModalConfig
} from './Templates/CreateFolderCollectionModal'
import ShareCollection, {
  ShareCollectionModalConfig
} from './Templates/ShareCollection'
import NewContentModal, {
  NewContentModalConfig
} from './Templates/NewContentModal'
import AddToCollection from './Templates/AddToCollection'
import {
  CollectionFiltersModal,
  CollectionFiltersModalConfig
} from './Templates/CollectionFilters'
import ContentDetailsModal, {
  ContentDetailsModalConfig
} from './Templates/ContentDetails'
import ContentSuggestionModal, {
  ContentSuggestionModalConfig
} from './Templates/ContentSuggestion'

const Modal = () => {
  const { showModal, settings, MODAL_TYPES } = useModal()

  const getModalByType = (type: modalTypes) => {
    switch (type) {
      case MODAL_TYPES.alert:
        return (
          <AlertStyleModal config={settings.config as AlertStyleModalConfig} />
        )

      case MODAL_TYPES.content_details:
        return (
          <ContentDetailsModal
            config={settings.config as ContentDetailsModalConfig}
          />
        )

      case MODAL_TYPES.content_suggestion:
        return (
          <ContentSuggestionModal
            config={settings.config as ContentSuggestionModalConfig}
          />
        )

      case MODAL_TYPES.edit_avatar:
        return <EditAvatarModal />

      case MODAL_TYPES.edit_language:
        return <EditLanguageModal />

      case MODAL_TYPES.edit_password:
        return <EditPasswordModal />

      case MODAL_TYPES.edit_data:
        return <EditPersonalDataModal />

      case MODAL_TYPES.edit_guardian_data:
        return <EditGuardianDataModal config={settings.config} />

      case MODAL_TYPES.viewer_help:
        return <ViewerHelpModal />

      case MODAL_TYPES.banner_video:
        return <BannerVideoModal config={settings.config} />

      case MODAL_TYPES.rename_collection:
        return (
          <RenameCollectionModal
            config={settings.config as RenameCollectionModalConfig}
          />
        )

      case MODAL_TYPES.delete_collection:
        return (
          <DeleteCollectionModal
            config={settings.config as DeleteCollectionModalConfig}
          />
        )

      case MODAL_TYPES.move_collection:
        return (
          <MoveCollectionModal
            config={settings.config as MoveCollectionModalConfig}
          />
        )

      case MODAL_TYPES.create_collection_folder:
        return (
          <CreateFolderCollectionModal
            config={settings.config as CreateFolderCollectionModalConfig}
          />
        )

      case MODAL_TYPES.share_collection:
        return (
          <ShareCollection
            config={settings.config as ShareCollectionModalConfig}
          />
        )

      case MODAL_TYPES.new_content:
        return (
          <NewContentModal config={settings.config as NewContentModalConfig} />
        )

      case MODAL_TYPES.move_collection_drop:
        return (
          <MoveCollectionDropModal
            config={settings.config as MoveCollectionDropModalConfig}
          />
        )

      case MODAL_TYPES.add_to_collection:
        return <AddToCollection config={settings.config} />

      case MODAL_TYPES.collection_filters:
        return (
          <CollectionFiltersModal
            config={settings.config as CollectionFiltersModalConfig}
          />
        )

      default:
        return null
    }
  }

  return (
    showModal && (
      <S.Overlay id="ba_modal_overlay">
        <S.ModalBody id="ba_modal" className={settings.classes}>
          {getModalByType(settings.type)}
        </S.ModalBody>
      </S.Overlay>
    )
  )
}

export default Modal
